import { Breadcrumb } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { baseUrl } from "../../../components/common/baseUrl";
import { useNotify } from "../../../components/Notification";
import { loadMenu } from "../../../auth/session";
import { settings } from "../../../utils/config";
import CreateMenuForm from "./CreateMenuForm";

const EditMenuPage = () => {
  const { id } = useParams();
  const notify = useNotify();
  const hasAccessToken = settings?.getCookie("access_token");

  //#region  state
  const [dataDetailMenu, setDataDetailMenu] = useState();
  //#endregion state

  //#region  function
  const fetchActions = async (page = 1, perPage = 10) => {
    try {
      const url = `${baseUrl}/api/v1/security/menus/${id}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hasAccessToken}`,
        },
      });

      if (response.data.success && response.data.data) {
        const result = response.data.data;
        setDataDetailMenu(result || []);
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.response?.data?.message,
      });
    } finally {
    }
  };
  const handleUpdate = async (data) => {
    const request = {
      name: data.name,
      slug: data.key,
      url: data.url,
      parent_id: data.parent_id || null,
      icon: data.icon,
      permission_ids: Array.isArray(data.listPermission)
        ? data.listPermission
            .map((item) => item.permission_id || item?.pivot?.permission_id || item.id)
            .filter(Boolean)
        : [],
    };
    try {
      const response = await axios.put(
        `${baseUrl}/api/v1/security/menus/${id}`,
        request,
        {
          headers: {
            Authorization: `Bearer ${hasAccessToken}`,
          },
        }
      );

      if (response) {
        notify.success({
          message: "Thành công",
          description: "Cập nhật menu thành công!",
        });
        fetchActions();
        // force: menu vừa đổi, sidebar phải thấy ngay chứ không chờ hết cache
        loadMenu({ force: true });
      }
    } catch (error) {
      const errorMessages = Object.entries(error)
        .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
        .join(" | ");
      notify.error({
        message: "Thất bại",
        description: errorMessages || "Vui lòng kiểm tra lại thông tin!",
      });
    } finally {
    }
  };

  useEffect(() => {
    fetchActions();
  }, []);

  return (
    <>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <NavLink to="/menu" style={{ textDecoration: "none" }}>
            Danh sách Menu
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Thông tin chung của Menu</Breadcrumb.Item>
      </Breadcrumb>
      <CreateMenuForm
        handleSubmit={(data) => handleUpdate(data)}
        title={"Thông tin chung"}
        initData={dataDetailMenu}
      />
    </>
  );
};
export default EditMenuPage;
